export default function QuantitySelector({ value, onChange, max = 10 }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className="w-full border rounded-lg px-4 py-2 text-gray-700"
    >
      {[...Array(max)].map((_, i) => (
        <option key={i + 1} value={i + 1}>
          {i + 1}
        </option>
      ))}
    </select>
  );
}
